import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Lock, ShieldCheck, EyeOff } from 'lucide-react';
import { REGIONS, CATEGORIES, OFFERS } from '../data/mock';
import { CITIES } from '../data/cities';

const regionList = REGIONS.filter((r) => r !== 'Alle Regionen' && r !== 'Online');
const categoryList = CATEGORIES.filter((c) => c !== 'Alle');

const Chip = ({ to, children }) => (
  <Link to={to} className="text-[#7a6b65] hover:text-[#e8a3b8] transition-colors">
    {children}
  </Link>
);

const LinkBlock = ({ title, children }) => (
  <div>
    <h4 className="text-white text-sm font-medium mb-3">{title}</h4>
    <div className="flex flex-col gap-1.5 text-xs leading-relaxed">{children}</div>
  </div>
);

const Footer = () => {
  return (
    <footer className="mt-20 border-t border-[#2a1f24] bg-[#15101280]">
      {/* SEO link directory */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 border-b border-[#2a1f24]">
        <h3 className="font-serif text-xl text-white mb-6">Sex Inserate in der ganzen Schweiz</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-8">
          <LinkBlock title="Sex Inserate nach Stadt">
            {CITIES.map((c) => (
              <Chip key={c.slug} to={`/sex-inserate/${c.slug}`}>
                Sex Inserate {c.name}
              </Chip>
            ))}
          </LinkBlock>

          <LinkBlock title="Sex Inserate nach Kanton">
            {regionList.map((r) => (
              <Chip key={r} to={`/inserate?region=${encodeURIComponent(r)}`}>
                Sex Inserate {r}
              </Chip>
            ))}
          </LinkBlock>

          <LinkBlock title="Kategorien">
            {categoryList.map((c) => (
              <Chip key={c} to={`/inserate?category=${encodeURIComponent(c)}`}>
                {c}
              </Chip>
            ))}
          </LinkBlock>

          <LinkBlock title="Angebote">
            {OFFERS.map((o) => (
              <Chip key={o} to={`/inserate?q=${encodeURIComponent(o)}`}>
                {o}
              </Chip>
            ))}
          </LinkBlock>
        </div>
      </div>

      {/* Sexinserate & Kontaktanzeigen directory */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 border-b border-[#2a1f24]">
        <h3 className="font-serif text-xl text-white mb-6">Sexinserate &amp; Kontaktanzeigen</h3>
        <div className="space-y-6">
          <div>
            <h4 className="text-white text-sm font-medium mb-3">Sexinserate</h4>
            <div className="flex flex-wrap gap-x-4 gap-y-2 text-xs">
              {CITIES.map((c) => (
                <Chip key={c.slug} to={`/sex-inserate/${c.slug}`}>
                  Sexinserate {c.name}
                </Chip>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-white text-sm font-medium mb-3">Kontaktanzeigen</h4>
            <div className="flex flex-wrap gap-x-4 gap-y-2 text-xs">
              {CITIES.map((c) => (
                <Chip key={c.slug} to={`/sex-inserate/${c.slug}`}>
                  Kontaktanzeigen {c.name}
                </Chip>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-md bg-gradient-to-br from-[#a83a5b] to-[#5e1c30] flex items-center justify-center">
                <Heart className="w-3.5 h-3.5 text-white fill-white" />
              </div>
              <span className="font-serif text-white text-base">matchdate.ch</span>
            </div>
            <p className="text-sm text-[#7a6b65] leading-relaxed">
              Schweizer Plattform für diskrete Dating-Inserate. Verschlüsselt, werbefrei, ohne Tracking.
            </p>
          </div>

          <div>
            <h4 className="text-white text-sm font-medium mb-3">Plattform</h4>
            <ul className="space-y-2 text-sm text-[#7a6b65]">
              <li><Link to="/inserate" className="hover:text-white transition-colors">Inserate</Link></li>
              <li><Link to="/clubs" className="hover:text-white transition-colors">Clubs</Link></li>
              <li><Link to="/jobs" className="hover:text-white transition-colors">Jobs</Link></li>
              <li><Link to="/immobilien" className="hover:text-white transition-colors">Immobilien</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white text-sm font-medium mb-3">Rechtliches</h4>
            <ul className="space-y-2 text-sm text-[#7a6b65]">
              <li><a href="#" className="hover:text-white transition-colors">AGB</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Datenschutz</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Impressum</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Kontakt</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white text-sm font-medium mb-3">Vertrauen</h4>
            <ul className="space-y-3 text-sm text-[#7a6b65]">
              <li className="flex items-center gap-2"><Lock className="w-3.5 h-3.5 text-[#c19a8a]" /> Verschlüsselt</li>
              <li className="flex items-center gap-2"><EyeOff className="w-3.5 h-3.5 text-[#c19a8a]" /> Kein Tracking</li>
              <li className="flex items-center gap-2"><ShieldCheck className="w-3.5 h-3.5 text-[#c19a8a]" /> 18+ Verifiziert</li>
            </ul>
          </div>
        </div>

        <div className="pt-6 border-t border-[#2a1f24] flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#5a4d48]">
          <p>© {new Date().getFullYear()} matchdate.ch — Alle Rechte vorbehalten.</p>
          <p>Werbefrei. Diskret. Schweiz.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
